import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router';
import store from '@/store'
Vue.use(ElementUI);
import 'normalize.css';

import axios from 'axios';
import config from '@/config'
axios.defaults.baseURL = config.baseURL;
Vue.prototype.$http = axios;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')